// Simple ID encoding/decoding for URLs
// Uses base64 with a salt to obscure database IDs

const SALT = 'mh_chat_'

export function encodeId(id: number): string {
  const salted = `${SALT}${id}_${Date.now() % 1000}`
  return btoa(salted).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export function decodeId(hash: string): number | null {
  try {
    // Add back padding if needed
    let padded = hash.replace(/-/g, '+').replace(/_/g, '/')
    while (padded.length % 4) {
      padded += '='
    }

    const decoded = atob(padded)
    const match = decoded.match(/^mh_chat_(\d+)_\d+$/)

    if (match) {
      return parseInt(match[1], 10)
    }

    // Fallback: try to parse as plain number (backwards compatibility)
    const num = parseInt(hash, 10)
    return isNaN(num) ? null : num
  } catch {
    // Fallback: try to parse as plain number
    const num = parseInt(hash, 10)
    return isNaN(num) ? null : num
  }
}
